<template>
  <div id="AppProxyPay">
    <Row :gutter="16" style="margin-top: 12px">
      <Col span="4">
        <label style="display: flex; align-items: center">
          <span style="width: 140px">手机号搜索:</span>
          <Input
            type="text"
            clearable
            placeholder="输入手机号搜索"
            v-model="table.params.phone"
          />
        </label>
      </Col>
      <Col span="5">
        <label style="display: flex; align-items: center">
          <span style="width: 120px">限制登录:</span>
          <Select
            clearable
            filterable
            placeholder="筛选限制登录"
            v-model="table.params.is_login"
            @on-change="SearList"
          >
            <Option
              v-for="(item, index) in select.limit"
              :value="item.value"
              :key="index"
              :label="item.name"
            >
              {{ item.name }}
<!--              <span style="color: #bbb">（{{ item.value }}）</span>-->
            </Option>
          </Select>
        </label>
      </Col>
      <Col span="5">
        <label style="display: flex; align-items: center">
          <span style="width: 160px">赠送彩金限制:</span>
          <Select
            clearable
            filterable
            placeholder="筛选赠送彩金限制"
            v-model="table.params.is_money"
            @on-change="SearList"
          >
            <Option
              v-for="(item, index) in select.limit"
              :value="item.value"
              :key="index"
              :label="item.name"
            >
              {{ item.name }}
<!--              <span style="color: #bbb">（{{ item.value }}）</span>-->
            </Option>
          </Select>
        </label>
      </Col>
      <Col span="5">
        <label style="display: flex; align-items: center">
          <span style="width: 120px">转出限制:</span>
          <Select
            clearable
            filterable
            placeholder="筛选转出限制"
            v-model="table.params.is_put"
            @on-change="SearList"
          >
            <Option
              v-for="(item, index) in select.limit"
              :value="item.value"
              :key="index"
              :label="item.name"
            >
              {{ item.name }}
<!--              <span style="color: #bbb">（{{ item.value }}）</span>-->
            </Option>
          </Select>
        </label>
      </Col>
      <Col span="5">
        <label style="display: flex; align-items: center">
          <span style="width: 120px">玩家标签:</span>
          <Select
            clearable
            filterable
            placeholder="筛选玩家标签"
            v-model="table.params.tag"
            @on-change="SearList"
          >
            <Option
              v-for="(item, index) in select.taglist"
              :value="item.value"
              :key="index"
              :label="item.name"
            >
              {{ item.name }}
              <span style="color: #bbb">（{{ item.value }}）</span>
            </Option>
          </Select>
        </label>
      </Col>
    </Row>
    <Row style="margin-top: 20px">
      <Col span="2">
        <Button type="primary" @click="SearList">搜索</Button>
      </Col>
      <Col span="6" style="display: flex; justify-content: flex-end">
        <Button type="primary" @click="OpenModal1" style="margin-right: 10px"
          >添加手机号码</Button
        >
        <Button type="primary" @click="OpenModal3" style="margin-right: 10px"
          >批量玩家管理</Button
        >
      </Col>
    </Row>
    <Table
      style="margin-top: 12px"
      border
      :ref="table.ref"
      :columns="table.columns"
      :data="table.data"
      @on-selection-change="selectChange"
      :max-height="tableMaxHeight"
    />
    <Page
      show-total
      show-sizer
      style="margin-top: 12px"
      :page-size="table.params.page_size"
      :total="table.page_total"
      :current="table.page_current"
      @on-change="ChangePage"
      @on-page-size-change="ChangePageSize"
    />
    <!-- 风控账号 -->
    <Modal
      v-model="modal1.show"
      @on-cancel="CloseModal1"
      width="850"
      @on-ok="updateBlackPhone"
    >
      <p slot="header" style="color: #1c2438">
        <span>添加手机号黑名单</span>
      </p>
      <div>
        <Card shadow>
          <Form :label-width="100">
            <Row>
              <RadioGroup v-model="modal1.form.data.tag">
                <Radio :label="0" style="margin-right: 20px"
                  ><h3 style="display: inline-block">黑名单</h3></Radio
                >
                <Radio :label="1" style="margin-right: 20px"
                  ><h3 style="display: inline-block">异常玩家</h3></Radio
                >
                <Radio :label="2"
                  ><h3 style="display: inline-block">伙牌玩家</h3></Radio
                >
              </RadioGroup>
            </Row>
          </Form>
        </Card>
      </div>
      <div>
        <Form :model="modal1.form.data" :label-width="80">
          <FormItem label="手动输入:">
            <Input
              v-model="modal1.form.data.phones"
              maxlength="1199"
              type="textarea"
              placeholder="输入手机号,多个手机号用英文逗号分隔,单次不超过100个"
              :rows="4"
            />
          </FormItem>
          <FormItem label="备注:">
            <Input
              v-model="modal1.form.data.desc"
              maxlength="20"
              placeholder="备注信息，不超过20个字符"
            />
          </FormItem>
        </Form>
      </div>
      <div>
        <div style="position: relative">
          <Upload type="drag" action>
            <div style="padding: 20px 0; width: 65%; float: left">
              <Icon
                type="ios-cloud-upload"
                size="52"
                style="color: #3399ff"
              ></Icon>
              <p style="text-align: center">文件格式：【csv】的文件；</p>
              <p style="text-align: center">文件大小：不大于1M；</p>
            </div>
            <div style="padding: 20px 0; width: 35%; float: left">
              <p>上传文件示意图</p>
              <table
                border="1"
                cellpadding="10"
                cellspacing="0"
                style="margin-left: 25%; width: 50%"
              >
                <tr>
                  <th>phone</th>
                  <th>desc</th>
                </tr>
                <tr>
                  <td>152****7845</td>
                  <td>刷子1</td>
                </tr>
                <tr>
                  <td>182****2222</td>
                  <td></td>
                </tr>
              </table>

              <p style="margin-top: 10px">
                上传的文件内容必须带有表头，phone代表手机电话号码，desc代表备注文本
              </p>
            </div>
          </Upload>
          <input
            type="file"
            ref="upload"
            accept=".txt, .csv"
            class="outputlist_upload"
          />
        </div>
        <Form :label-width="100">
          <Row>
            <Col span="3" @click.native.prevent.stop="updateType(0)">
              <Radio :value="modal1.form.data.is_login">限制登录</Radio>
            </Col>
            <Col span="3" @click.native.prevent.stop="updateType(1)">
              <Radio :value="modal1.form.data.is_put">限制转出</Radio>
            </Col>
            <Col span="4" @click.native.prevent.stop="updateType(2)">
              <Radio :value="modal1.form.data.is_money">限制彩金赠送</Radio>
            </Col>
            <Col span="4" @click.native.prevent.stop="updateType(3)">
              <Radio :value="modal1.form.data.not_limit">不限制</Radio>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
    <!-- 更新备注信息 -->
    <Modal v-model="modal2.show" @on-cancel="CloseModal2">
      <div slot="header">修改信息</div>
      <Form :model="modal2.form.data" :label-width="120">
        <Row>
          <Col span="20">
            <FormItem label="限制权限:">
              <RadioGroup v-model="modal2.form.data.game_limit">
                <Radio :label="1">限制登录</Radio>
                <Radio :label="2">限制转出</Radio>
                <Radio :label="0">不限制</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="20">
            <FormItem label="自动彩金限制:">
              <RadioGroup v-model="modal2.form.data.point_limit">
                <Radio :label="0">不限制</Radio>
                <Radio :label="1">限制</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="备注信息">
              <Input
                type="text"
                placeholder="备注信息"
                v-model="modal2.form.data.desc"
              />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="updateExportAccount">提交</Button>
      </div>
    </Modal>
    <Modal v-model="modal3.show" @on-cancel="CloseModal2" width="850px">
      <div slot="header">批量玩家管理</div>
      <div>
        <Table
          :max-height="600"
          :data="modal3.table"
          :columns="modal3.columns"
          border
        ></Table>
        <Form :label-width="100" style="margin-top: 12px">
          <Row>
            <Col span="3" @click.native.prevent.stop="updateModal3Type(0)">
              <Radio :value="modal3.form.data.is_login">限制登录</Radio>
            </Col>
            <Col span="3" @click.native.prevent.stop="updateModal3Type(1)">
              <Radio :value="modal3.form.data.is_put">限制转出</Radio>
            </Col>
            <Col
              span="3"
              @click.native.prevent.stop="updateModal3Type(2)"
              style="margin-right: 16px"
            >
              <Radio :value="modal3.form.data.is_money">限制彩金赠送</Radio>
            </Col>
            <Col span="3" @click.native.prevent.stop="updateModal3Type(3)">
              <Radio :value="modal3.form.data.is_del">批量删除</Radio>
            </Col>
          </Row>
        </Form>
      </div>

      <div slot="footer">
        <Button @click="modal3.show = false">取消</Button>
        <Button type="primary" @click="batchUpdateBlackPhone">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  ExportBlackPhone,
  SearchBlackPhone,
  UpdateBlackPhone,
  BatchUpdateBlackPhone
} from '@/api/admin/risk'
export default {
  name: 'blackPhone',
  data() {
    return {
      tableMaxHeight: 0,
      select: {
        limit: [
          { name: '否', value: 0 },
          { name: '是', value: 1 }
        ],
        taglist: [
          { value: 0, name: '黑名单' },
          { value: 1, name: '异常玩家' },
          { value: 2, name: '伙牌玩家' }
        ]
      },
      table: {
        ref: 'table',
        params: {
          phone: '',
          page: 1,
          page_size: 10,
          is_money: -1,
          is_login: -1,
          is_put: -1,
          tag: -1
        },
        columns: [
          { type: 'selection', align: 'center', width: 60 },
          { title: '手机号', key: 'phone', minWidth: 100, align: 'center' },
          {
            title: '玩家标签',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              let find = this.select.taglist.find(
                el => el.value == params.row.tag
              ) || { name: '' }
              return h('span', find.name)
            }
          },
          {
            title: '是否限制登录',
            key: 'is_login',
            minWidth: 100,
            align: 'center',
            render: (h, params) => this.renderLimit(h, params.row.is_login)
          },
          {
            title: '是否赠送彩金',
            key: 'is_money',
            minWidth: 100,
            align: 'center',
            render: (h, params) => this.renderLimit(h, params.row.is_money)
          },
          {
            title: '是否限制转出',
            key: 'is_put',
            minWidth: 100,
            align: 'center',
            render: (h, params) => this.renderLimit(h, params.row.is_put)
          },
          { title: '创建时间', key: 'itime', minWidth: 100, align: 'center' },
          {
            title: '最后修改时间',
            key: 'utime',
            minWidth: 120,
            align: 'center'
          },
          { title: '备注信息', key: 'desc', minWidth: 100, align: 'center' },
          {
            title: '快速删除',
            align: 'center',
            width: 160,
            render: (h, params) =>
              h(
                'Button',
                {
                  props: { type: 'error' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '确认删除',
                        onOk: () => {
                          this.Delete(params.row)
                        }
                      })
                    }
                  }
                },
                '删除'
              )
          }
        ],
        data: []
      },
      modal3: {
        show: false,
        table: [],
        columns: [
          { title: '手机号', key: 'phone', minWidth: 100, align: 'center' },
          {
            title: '玩家标签',
            key: 'tag',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              let find = this.select.taglist.find(
                el => el.value == params.row.tag
              ) || { name: '' }
              return h('span', find.name)
            }
          },
          {
            title: '是否限制登录',
            key: 'is_login',
            minWidth: 100,
            align: 'center',
            render: (h, params) => this.renderLimit(h, params.row.is_login)
          },
          {
            title: '是否赠送彩金',
            key: 'is_money',
            minWidth: 100,
            align: 'center',
            render: (h, params) => this.renderLimit(h, params.row.is_money)
          },
          {
            title: '是否限制转出',
            key: 'is_put',
            minWidth: 100,
            align: 'center',
            render: (h, params) => this.renderLimit(h, params.row.is_put)
          },
          { title: '创建时间', key: 'itime', minWidth: 100, align: 'center' },
          {
            title: '最后修改时间',
            key: 'utime',
            minWidth: 130,
            align: 'center'
          },
          { title: '备注信息', key: 'desc', minWidth: 100, align: 'center' }
        ],
        form: {
          ref: 'modal3_form',
          data: {}
        }
      },
      modal1: {
        show: false,
        form: {
          ref: 'modal1_form',
          data: { config: {} }
        }
      },
      modal2: {
        show: false,
        type: 'add',
        form: {
          ref: 'modal1_form',
          data: { config: {} }
        }
      },
      selectData: []
    }
  },
  methods: {
    renderLimit(h, val) {
      if (val == 0) {
        return h('span', { style: { color: 'red' } }, '否')
      } else {
        return h('span', { style: { color: '#32CD32' } }, '是')
      }
    },
    GetList() {
      let params = { ...this.table.params }
      params.is_put = params.is_put == undefined ? -1 : params.is_put
      params.is_money = params.is_money == undefined ? -1 : params.is_money
      params.is_login = params.is_login == undefined ? -1 : params.is_login
      params.tag = params.tag == undefined ? -1 : params.tag
      SearchBlackPhone(params).then(res => {
        let data = res._param
        this.table.data = data.data || []
        this.selectData = []
        this.table['page_total'] = data.total
      })
    },
    ChangePage(page) {
      this.table.params.page = page
      this.table['page_current'] = page
      this.GetList()
    },
    ChangePageSize(page_size) {
      this.table.params.page = 1
      this.table['page_current'] = 1
      this.table.params.page_size = page_size
      this.GetList()
    },
    SearList() {
      this.table.params.page = 1
      this.$refs[this.table.ref]['currentPage'] = 1
      this.table['page_current'] = 1
      this.GetList()
    },
    selectChange(param) {
      this.selectData = this.copyData(param)
    },
    OpenModal3() {
      this.modal3.table = this.selectData
      if (!this.selectData.length) {
        this.$Message.info('请选择至少一条数据')
        return
      }
      this.modal3.show = true
      let data = {
        is_login: false,
        is_money: false,
        is_put: false,
        is_del: false
      }
      this.modal3.form.data = data
    },
    // 编辑和新增
    OpenModal1() {
      this.modal1.show = true
      let data = { is_login: true, is_money: false, is_put: false, tag: 0 }
      this.modal1.form.data = data
    },
    updateModalData() {
      if (!this.modal3.show) {
        this.modal3.table = []
      }
    },
    updateModal3Type(type) {
      // let { is_login, is_put, is_money } = this.modal1.form.data;
      // let arr = [is_login, is_put, is_money];
      // if (arr[type] == true) {
      //     let count = Number(is_login) + Number(is_put) + Number(is_money);
      //     if (count < 2) return;
      // }
      switch (type) {
        case 0:
          this.modal3.form.data.is_del = false
          this.modal3.form.data.is_login = !this.modal3.form.data.is_login
          break
        case 1:
          this.modal3.form.data.is_del = false
          this.modal3.form.data.is_put = !this.modal3.form.data.is_put
          break
        case 2:
          this.modal3.form.data.is_del = false
          this.modal3.form.data.is_money = !this.modal3.form.data.is_money
          break
        case 3:
          this.modal3.form.data.is_del = !this.modal3.form.data.is_del
          if (this.modal3.form.data.is_del) {
            this.modal3.form.data.is_money = false
            this.modal3.form.data.is_put = false
            this.modal3.form.data.is_login = false
          }
          break
      }
    },
    batchUpdateBlackPhone() {
      if (this.modal3.table.length == 0) {
        this.modal3.show = false
      } else {
        this.$Modal.confirm({
          title: this.modal3.form.data.is_del
            ? '确定删除吗？'
            : '确定要进行修改吗？',
          onOk: () => {
            let ids = this.modal3.table.map(item => item.id)
            let { is_login, is_put, is_money, is_del } = this.modal3.form.data
            BatchUpdateBlackPhone({
              is_login: Number(is_login),
              is_put: Number(is_put),
              is_money: Number(is_money),
              is_del: Number(is_del),
              ids
            }).then(res => {
              this.$Message.success('批量修改成功')
              this.modal3.show = false
              this.GetList()
            })
          }
        })
      }
    },
    updateType(type) {
      let { is_login, is_put, is_money, not_limit } = this.modal1.form.data
      let arr = [is_login, is_put, is_money]
      if (arr[type] == true) {
        let count = Number(is_login) + Number(is_put) + Number(is_money)
        if (count < 2) return
      }
      switch (type) {
        case 0:
          this.modal1.form.data.not_limit = false
          this.modal1.form.data.is_login = !this.modal1.form.data.is_login
          break
        case 1:
          this.modal1.form.data.not_limit = false
          this.modal1.form.data.is_put = !this.modal1.form.data.is_put
          break
        case 2:
          this.modal1.form.data.not_limit = false
          this.modal1.form.data.is_money = !this.modal1.form.data.is_money
          break
        case 3:
          this.modal1.form.data.is_login = false
          this.modal1.form.data.is_put = false
          this.modal1.form.data.is_money = false
          this.modal1.form.data.not_limit = true
          break
      }
    },
    CloseModal1() {
      // this.$refs[this.modal1.form.ref].resetFields();
      this.modal1.show = false
    },
    updatePhonesNumber() {
      let nowData = this.modal1.form.data.phones || ''
      nowData = nowData.replace(/\,\,/gi, ',')
      let nowArr = nowData.split(',')
      if (nowArr.length > 100) {
        nowData = nowArr.slice(0, 100).join(',')
      }
      this.modal1.form.data.phones = nowData
    },
    Update() {
      let params = { ...this.modal1.form.data }
      ExportBlackPhone(params).then(res => {
        this.CloseModal1()
        this.GetList()
      })
    },

    readExcel(e) {
      //表格导入
      let that = this
      const files = e.target.files
      if (files[0].size > 1024 * 1024 * 1) {
        this.$Message.error('上传文件内容不能大于1M')
        return false
      }
      const fileReader = new FileReader()
      // let nametxt = files[0].name.substring(0,files[0].name.length-4)
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          let {
            is_login,
            is_money,
            is_put,
            tag,
            phones,
            desc
          } = this.modal1.form.data
          const param = {
            phones,
            desc,
            is_login: Number(is_login),
            is_money: Number(is_money),
            is_put: Number(is_put),
            tag,
            data,
            name: files[0].name
          }
          ExportBlackPhone(param).then(res => {
            this.modal1.show = false
            this.$Message.success('上传文件内容成功')
            this.$refs.upload['value'] = ''
            this.GetList()
          })
        } catch (e) {
          return false
        }
      }
      fileReader.readAsText(files[0], 'gb2312')
    },
    OpenModal2(type, row = {}) {
      this.modal2.show = true
      let data = { desc: '', ...row }
      this.modal2.form.data = data
    },
    updateExportAccount() {
      let params = {
        id: this.modal2.form.data['id'],
        game_limit: Number(this.modal2.form.data['game_limit']),
        point_limit: Number(this.modal2.form.data['point_limit']),
        desc: this.modal2.form.data['desc']
      }
      UpdateBlackPhone(params).then(res => {
        this.CloseModal2()
        this.GetList()
      })
    },
    updateBlackPhone() {
      if (this.modal1.form.data.phones == '') {
        this.modal1.show = false
        return
      }
      let {
        is_login,
        is_money,
        is_put,
        tag,
        phones,
        desc
      } = this.modal1.form.data
      const param = {
        phones,
        desc,
        is_login: Number(is_login),
        is_money: Number(is_money),
        is_put: Number(is_put),
        tag: Number(tag),
        data: '',
        name: ''
      }
      ExportBlackPhone(param).then(res => {
        this.modal1.show = false
        this.$Message.success('添加成功')
        this.$refs.upload['value'] = ''
        this.GetList()
      })
    },
    Delete(item) {
      let params = { id: item.id, type: 1, desc: item.desc }
      UpdateBlackPhone(params).then(res => {
        this.CloseModal2()
        this.GetList()
      })
    },
    CloseModal2() {
      this.modal2.show = false
    }
  },
  watch: {
    'modal3.show': function() {
      this.updateModalData()
    },
    'modal1.form.data.phones': function() {
      this.updatePhonesNumber()
    }
  },
  mounted() {
    this.GetList()
    this.tableMaxHeight = window.document.body.clientHeight - 270
    this.$refs.upload.addEventListener('change', e => {
      //绑定监听表格导入事件
      this.readExcel(e)
    })
  }
}
</script>

<style lang="less">
#AppProxyPayModal {
  .ivu-form-item {
    margin-bottom: 10px;
  }
  .linesp span {
    display: inline-block;
    width: 100%;
    border: 1px solid #999;
    margin-bottom: 8px;
  }
}
</style>
<style scoped lang="less">
.outputlist_upload {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
/deep/ .ivu-card-shadow {
  box-shadow: none !important;
}
</style>
